import { render, staticRenderFns } from "./search-form-item-select.vue?vue&type=template&id=34b97b21"
import script from "./search-form-item-select.vue?vue&type=script&lang=js"
export * from "./search-form-item-select.vue?vue&type=script&lang=js"
import style0 from "./search-form-item-select.vue?vue&type=style&index=0&id=34b97b21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports